import WebApi from "@/views/loyalty/shared/modules/web_api"
import { monitoring_last_record_model, monitoring_model } from "@/views/monitoring/shared/models/monitoring.model"

export class MonitoringEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_MONITORING_URL}api/monitoring/`
        console.log('url', this.url)
        this.webApi = new WebApi()
    }

    async getLastRecordOfMonitoring (pointIdAndTimeZone) {
        const action = await this.webApi.post(`${this.url}lastrecord`, pointIdAndTimeZone)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
            return monitoring_last_record_model
        }
    }

    // get offline points like [{pointId: "..", updated: ".."}]
    async getOfflinePoints (pointIds) {
        const action = await this.webApi.post(`${this.url}OfflinePoints`, pointIds)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
        }
    }

    async getRecordForDashboard (pointIds) {
        const action = await this.webApi.post(`${this.url}dashboard`, pointIds)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
        }
    }
}
